/*
 * ITALIANO — Avviso Proprietario / Copyright & IP Notice (Ultra-Restrittivo)
 *
 *   Copyright (c) 2026.
 *
 *   Copyright © 2026 PhepTech di Pietro Guglielmi. Tutti i diritti riservati.
 *   Copyright © 2026 Pietro Guglielmi. Tutti i diritti riservati.
 *
 *   1) Natura proprietaria – Nessuna licenza
 *
 *   Questo software e tutto il relativo materiale (inclusi, a titolo esemplificativo e
 *   non esaustivo: codice sorgente e/o oggetto, file, moduli, classi, funzioni, metodi,
 *   algoritmi, strutture dati, architettura, API, interfacce, UI/UX, testi, grafica,
 *   risorse, configurazioni, build logic, documentazione, specifiche e ogni derivato)
 *   sono opera protetta e/o contenuto proprietario di Pietro Guglielmi e/o PhepTech di
 *   Pietro Guglielmi (“Titolare”).
 *
 *   Nessuna licenza o diritto d’uso è concesso con la sola disponibilità, visione,
 *   accesso, download, clonazione, consegna o possesso del Software, salvo quanto
 *   espressamente autorizzato per iscritto dal Titolare tramite contratto o licenza
 *   separata firmata.
 *
 *   Sono esclusi tutti i diritti impliciti, inclusi (senza limitazione) diritti per
 *   implicazione, consuetudine, “estoppel” o altrimenti.
 *
 *   2) Divieti assoluti (salvo autorizzazione scritta)
 *
 *   È severamente vietato, in tutto o in parte, e con qualsiasi mezzo o finalità
 *   (inclusa finalità didattica, commerciale o concorrente), salvo esplicita
 *   autorizzazione scritta del Titolare:
 *
 *   - copiare, riprodurre, trascrivere, pubblicare, caricare, trasmettere, distribuire,
 *     ridistribuire, condividere, cedere, vendere, sublicenziare, noleggiare, prestare o
 *     rendere disponibile a terzi il Software;
 *
 *   - modificare, adattare, tradurre, trasformare, creare opere derivate, integrare o
 *     incorporare in altri prodotti/servizi, o utilizzare il Software per creare o
 *     addestrare modelli, dataset, automazioni o strumenti (inclusi sistemi di AI/ML)
 *     che ne replichino funzionalità o valore;
 *
 *   - effettuare reverse engineering, decompilare, disassemblare, decodificare o
 *     tentare di ricavare il sorgente, le chiavi, le logiche o i meccanismi interni;
 *     aggirare, disattivare o eludere misure di sicurezza/controllo accessi/DRM o
 *     meccanismi di protezione;
 *
 *   - rimuovere, alterare o occultare avvisi di copyright, marchi, attribuzioni,
 *     watermark o indicazioni di riservatezza.
 *
 *   Eccezione obbligatoria: quanto sopra vale nella massima misura consentita dalla
 *   legge applicabile; eventuali usi consentiti imperativamente dalla legge restano
 *   limitati allo stretto necessario.
 *
 *   3) Riservatezza e segreti commerciali (se applicabile)
 *
 *   Nella misura in cui il Software o parti di esso non siano stati resi pubblicamente
 *   disponibili dal Titolare, essi costituiscono Informazioni Riservate e possono
 *   integrare segreti commerciali.
 *
 *   È obbligatorio adottare misure di protezione almeno ragionevoli e comunque non
 *   inferiori a quelle usate per proteggere i propri segreti commerciali, e non
 *   divulgarli a terzi.
 *
 *   4) Titolarità, feedback e diritti IP
 *
 *   Il Software è di esclusiva titolarità del Titolare. Tutti i diritti di proprietà
 *   intellettuale e industriale (copyright, know-how, segreti commerciali, diritti su
 *   banche dati, marchi, brevetti — ove applicabili) restano del Titolare.
 *
 *   Qualsiasi idea, segnalazione, proposta di miglioramento o feedback comunicato al
 *   Titolare potrà essere utilizzato liberamente dal Titolare senza obbligo di
 *   compenso, attribuzione o restrizioni, nella misura consentita dalla legge.
 *
 *   5) Tutela e rimedi
 *
 *   Qualsiasi violazione può causare un danno grave e irreparabile. Il Titolare potrà
 *   richiedere inibitoria immediata, sequestro, rimozione dei contenuti, risarcimento
 *   danni, restituzione dei profitti e ogni ulteriore rimedio previsto dalla legge,
 *   incluse (ove consentite) spese legali.
 *
 *   6) Esclusione di garanzie e limitazione di responsabilità
 *
 *   Il Software è fornito “così com’è” e “come disponibile”, senza garanzie di alcun
 *   tipo, espresse o implicite, incluse (senza limitazione) garanzie di commerciabilità,
 *   idoneità a scopo particolare, non violazione, accuratezza o assenza di errori.
 *
 *   Nella massima misura consentita dalla legge, il Titolare non sarà responsabile per
 *   danni indiretti, incidentali, consequenziali, speciali, punitivi, perdita di
 *   profitti, dati o interruzione attività.
 *
 *   7) Legge applicabile e foro
 *
 *   Salvo norme inderogabili, il presente avviso e qualsiasi uso/non-uso del Software
 *   sono regolati dalla legge italiana. Ogni controversia è devoluta in via esclusiva
 *   al Foro di [MILANO] (sostituisci se preferisci altro foro).
 *
 *   8) Protezione internazionale
 *
 *   Il Software è protetto a livello internazionale secondo i principi di tutela
 *   automatica e “national treatment” previsti da convenzioni e accordi internazionali
 *   in materia di diritto d’autore e proprietà intellettuale (es. Convenzione di Berna,
 *   TRIPS), nei rispettivi Paesi aderenti.
 *
 *
 *   ENGLISH — Proprietary Notice / Copyright & IP Notice (Ultra-Restrictive)
 *
 *   Copyright (c) 2026.
 *
 *   Copyright © 2026 PhepTech di Pietro Guglielmi. All rights reserved.
 *   Copyright © 2026 Pietro Guglielmi. All rights reserved.
 *
 *   1) Proprietary nature – No license granted
 *
 *   This software and all related materials (including, without limitation: source
 *   and/or object code, files, modules, classes, functions, methods, algorithms, data
 *   structures, architecture, APIs, interfaces, UI/UX, text, graphics, assets,
 *   configurations, build logic, documentation, specifications, and any derivatives)
 *   are proprietary to Pietro Guglielmi and/or PhepTech di Pietro Guglielmi (“Owner”)
 *   and are protected by applicable intellectual property laws.
 *
 *   No license or right is granted by mere access, viewing, possession, delivery,
 *   download, cloning, or use of the Software, unless expressly authorized in writing
 *   by the Owner under a separate signed agreement/license.
 *
 *   All implied licenses are expressly disclaimed, including by implication, custom,
 *   estoppel, or otherwise.
 *
 *   2) Strict prohibitions (unless prior written permission)
 *
 *   You are strictly prohibited, in whole or in part, by any means and for any purpose
 *   (including educational, commercial, or competitive purposes), unless you have the
 *   Owner’s prior written permission, from:
 *
 *   - copying, reproducing, publishing, uploading, transmitting, distributing,
 *     re-distributing, sharing, selling, assigning, sublicensing, renting, leasing,
 *     lending, or otherwise making the Software available to any third party;
 *
 *   - modifying, adapting, translating, transforming, creating derivative works,
 *     integrating, incorporating into other products/services, or using the Software to
 *     build or train models, datasets, automations, or tools (including AI/ML systems)
 *     that replicate its functionality or value;
 *
 *   - reverse engineering, decompiling, disassembling, decoding, or attempting to
 *     derive source code, keys, logic, internal mechanisms; bypassing, disabling, or
 *     circumventing security/access controls/DRM or other protection measures;
 *
 *   - removing, altering, or obscuring copyright notices, trademarks, attributions,
 *     watermarks, or confidentiality markings.
 *
 *   Mandatory legal carve-out: the above applies to the maximum extent permitted by
 *   applicable law; any non-waivable statutory rights remain limited to what the law
 *   strictly requires.
 *
 *   3) Confidentiality & trade secrets (where applicable)
 *
 *   To the extent the Software (or any portion thereof) has not been publicly disclosed
 *   by the Owner, it constitutes Confidential Information and may include trade
 *   secrets. You must protect it using at least reasonable safeguards and must not
 *   disclose it to any third party.
 *
 *   4) Ownership, feedback, and IP rights
 *
 *   The Software is exclusively owned by the Owner. All intellectual and industrial
 *   property rights (copyright, know-how, trade secrets, database rights, trademarks,
 *   patents—where applicable) remain with the Owner.
 *
 *   Any ideas, suggestions, improvements, or feedback you provide may be used by the
 *   Owner without compensation, attribution, or restrictions, to the extent permitted
 *   by law.
 *
 *   5) Enforcement & remedies
 *
 *   Any violation may cause irreparable harm. The Owner may seek immediate injunctive
 *   relief, takedowns, seizure/impoundment where available, damages, disgorgement of
 *   profits, and any other remedies allowed by law, including attorneys’ fees where
 *   permitted.
 *
 *   6) Disclaimer of warranties & limitation of liability
 *
 *   The Software is provided “AS IS” and “AS AVAILABLE”, without warranties of any
 *   kind, express or implied, including merchantability, fitness for a particular
 *   purpose, non-infringement, accuracy, or error-free operation.
 *
 *   To the maximum extent permitted by law, the Owner shall not be liable for indirect,
 *   incidental, consequential, special, exemplary, or punitive damages, loss of profits
 *   or data, or business interruption.
 *
 *   7) Governing law & jurisdiction
 *
 *   Except where mandatory law provides otherwise, this notice and any use/non-use of
 *   the Software shall be governed by the laws of Italy, with exclusive jurisdiction in
 *   the courts of [MILAN] (edit as desired).
 *
 *   8) International protection
 *
 *   The Software is protected internationally under the principles of automatic
 *   protection and national treatment reflected in major international copyright/IP
 *   frameworks (e.g., the Berne Convention and TRIPS), in their respective member
 *   countries.
 */

package com.pheptech.kmp.newborn.demo5

import androidx.compose.runtime.Composable
import com.pheptech.kmp.newborn.demo5.theme.AppStyles
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ExplanationPage(target: Screen, onNav: (Screen, String?, String?, Screen?) -> Unit) {
    Div(attrs = { classes(AppStyles.container) }) {
        Section(attrs = { style { padding(4.cssRem, 0.px) } }) {
            Button(attrs = {
                classes(AppStyles.btn, AppStyles.btnOutline)
                style { marginBottom(2.cssRem) }
                onClick { onNav(target, null, null, null) }
            }) { Text("← Torna alla Pagina Reale") }

            when (target) {
                Screen.HOME -> ExplanationHome()
                Screen.BUSINESS_DASHBOARD -> ExplanationDashboard()
                Screen.ADMIN -> ExplanationAdmin()
                else -> P { Text("Spiegazione in arrivo per questa sezione.") }
            }
        }
    }
}

@Composable
fun ExplanationHome() {
    H2 { Text("Logica della Home Page") }
    Div(attrs = {
        style {
            display(DisplayStyle.Grid); property(
            "grid-template-columns",
            "repeat(auto-fit, minmax(350.px, 1fr))"
        ); gap(2.cssRem); marginBottom(3.cssRem)
        }
    }) {
        Div(attrs = { classes(AppStyles.card) }) {
            H4 { Text("Obiettivo Commerciale") }
            P { Text("La Home è progettata per massimizzare la fiducia dell'utente finale e la visibilità delle attività partner.") }
            Ul {
                Li { Text("6 Macroaree: Organizzazione chiara per facilitare la navigazione.") }
                Li { Text("Sezione Sponsor: Slot premium (1 per categoria) posizionato in alto.") }
                Li { Text("Sezione In Evidenza: Slot medio (6 per categoria) per visibilità garantita.") }
                Li { Text("Sezione Promo: Call-to-action immediata per incentivare il contatto.") }
            }
        }

        Div(attrs = { classes(AppStyles.card) }) {
            H4 { Text("Algoritmo di Ordinamento") }
            P { Text("Le liste sono ordinate dinamicamente seguendo questa gerarchia:") }
            Ol {
                Li { Text("Sponsor (Slot Premium)") }
                Li { Text("In Evidenza (Slot Gold)") }
                Li { Text("Da Provare (Slot Trial)") }
                Li { Text("Standard (Nessuno slot attivo)") }
            }
            P { Text("A parità di slot, prevale il livello del piano (L3 > L2 > L1) e infine l'ordine alfabetico.") }
        }
    }
}

@Composable
fun ExplanationDashboard() {
    H2 { Text("Logica Area Attività") }
    Div(attrs = {
        style {
            display(DisplayStyle.Grid); property(
            "grid-template-columns",
            "repeat(auto-fit, minmax(350.px, 1fr))"
        ); gap(2.cssRem); marginBottom(3.cssRem)
        }
    }) {
        Div(attrs = { classes(AppStyles.card) }) {
            H4 { Text("Strumenti di Crescita") }
            P { Text("La dashboard è differenziata per capabilities per incentivare l'upgrade ai piani superiori.") }
            Ul {
                Li { Text("L1: Solo dati anagrafici di base.") }
                Li { Text("L2: Possibilità di monitorare i click al sito web.") }
                Li { Text("L3: Analitiche complete (views, whatsapp, sito) + Gestione Promozioni.") }
            }
        }

        Div(attrs = { classes(AppStyles.card) }) {
            H4 { Text("Metrics Enforcement") }
            P { Text("Il sistema traccia i click unici per sourceHash per evitare manipolazioni delle metriche e garantire dati reali all'attività.") }
        }
    }
}

@Composable
fun ExplanationAdmin() {
    H2 { Text("Logica Area Admin") }
    Div(attrs = {
        style {
            display(DisplayStyle.Grid); property(
            "grid-template-columns",
            "repeat(auto-fit, minmax(350.px, 1fr))"
        ); gap(2.cssRem); marginBottom(3.cssRem)
        }
    }) {
        Div(attrs = { classes(AppStyles.card) }) {
            H4 { Text("Controllo e Qualità") }
            P { Text("L'amministratore ha il controllo totale per garantire la qualità dei contenuti sulla piattaforma.") }
            Ul {
                Li { Text("Approvazione: Nessuna attività è visibile pubblicamente senza l'ok dell'admin.") }
                Li { Text("Gestione Piani: Possibilità di cambiare il livello piano in tempo reale.") }
                Li { Text("Gestione Slot: Assegnazione manuale o automatizzata degli spazi commerciali.") }
                Li { Text("Oscuramento: Capacità di nascondere contenuti inappropriati o attività non in regola.") }
            }
        }

        Div(attrs = { classes(AppStyles.card) }) {
            H4 { Text("Sostenibilità del Modello") }
            P { Text("Il pannello fornisce una visione d'insieme della saturazione delle macroaree (es. slot sponsor occupati) per guidare le strategie commerciali locali.") }
        }
    }
}
